import {
  Flexbox, Form, PageHeader, Styles,
} from '@/components'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import { Link, useLocation } from 'react-router-dom'

const reportCategories = [
  {
    label: 'Por adoções',
    icon: 'fas fa-heart',
    path: 'adoptions',
  },
  {
    label: 'Por atendimento clínico',
    icon: 'fas fa-clinic-medical',
    path: 'clinical-cares',
  },
  {
    label: 'Por castrações',
    icon: 'fas fa-cut',
    path: 'castrations',
  },
  {
    label: 'Por feiras de adoção',
    icon: 'fas fa-dog',
    path: 'fairs',
  },
  {
    label: 'Por pets',
    icon: 'fas fa-paw',
    path: 'animals',
  },
]

function Menu({ title }) {
  usePageTitle({ title })

  const { pathname } = useLocation()

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        title="Relatórios disponíveis"
        subtitle="Selecione a categoria para ver a lista com os relatórios disponíveis"
        icon="fas fa-chart-area"
      />
      <Flexbox.Columns>
        {reportCategories.map(({ label, icon, path }) => (
          <Flexbox.Column key={label} className="col-8 col-sm-12">
            <Form.Group>
              <Link to={`${pathname}/${path}`} style={{ textDecoration: 'none' }}>
                <div className="bg-gray s-rounded p-1 mb-2 scale-animated">
                  <Flexbox.Columns>
                    <Flexbox.Column>
                      <div className="p-1">
                        <div className="text-dark">
                          <i className={icon} />
                          <b className="pl-2">{label}</b>
                        </div>
                      </div>
                    </Flexbox.Column>

                    <Flexbox.Column className="col-auto">
                      <div className="p-1">
                        <i className="fas fa-arrow-right" />
                      </div>
                    </Flexbox.Column>
                  </Flexbox.Columns>
                </div>
              </Link>
            </Form.Group>
          </Flexbox.Column>
        ))}
      </Flexbox.Columns>
    </Styles.Container>
  )
}

export default Menu
